import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CardMedia,
} from '@mui/material';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import Footer from '../navbar/Footer';
import moment from 'moment';

const bulletinsData = [
  {
    title: "Enquête Nationale sur la Situation Nutritionnelle et la Sécurité Alimentaire au Burundi de 2019 (ENSNSAB, 2019) | Rapport Principal",
    link: "/documents/enqueteNutritions/Rapport-ENSNSAB-2018_22.01.2020-1.pdf",
    date: "2019-08-01",
    image: 'assets/covers/cover5.PNG', 
    description: "L'enquête nationale sur la nutrition et la sécurité alimentaire (ISTEEBU, 2021) révèle que 44,4% des ménages burundais sont en insécurité alimentaire (dont 9,5% sévère), avec 43,9% ayant une consommation alimentaire inadéquate. Les provinces de Karusi, Gitega, Muramvya, Mwaro et Ngozi sont les plus affectées.",
  },
  {
    title: "Enquête Nationale sur la Situation Nutritionnelle et la Mortalité basée sur la Méthodologie SMART | Rapport Principal",
    link: "/documents/enqueteNutritions/ENSNMB_Rapport_Final_BDI_2018-2.pdf",
    date: "2018-01-01",
    image: 'assets/covers/cover6.PNG', 
    description: "L'enquête nationale révèle un taux de malnutrition aigüe de 4,5% (dont 0,5% de formes sévères) et une malnutrition chronique préoccupante de 57% (25,6% de formes sévères), avec des disparités selon l'âge, le sexe et la région, les enfants de 6-23 mois et les garçons étant les plus affectés.",
  },
];

function EnqueteNutrition() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredBulletins, setFilteredBulletins] = useState(bulletinsData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
  
    if (year === 'Tous') {
      const sortedBulletins = bulletinsData.sort((a, b) => new Date(b.date).getFullYear() - new Date(a.date).getFullYear());
      setFilteredBulletins(sortedBulletins);
    } else {
      const filtered = bulletinsData
        .sort((a, b) => new Date(b.date).getFullYear() - new Date(a.date).getFullYear())
        .filter((bulletin) => {
          const bulletinYear = new Date(bulletin.date).getFullYear().toString();
          return bulletinYear === year;
        });
      setFilteredBulletins(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  return (
    <ThemeProvider theme={createTheme()}>
      <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px', paddingInline: '20px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
            Rapports des Enquêtes Nutrition
          </Typography>
          <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1" align="left" gutterBottom>
  Les enquêtes nutritionnelles sont des outils essentiels pour évaluer l'état nutritionnel de la population burundaise. Les données collectées permettent de comprendre les défis nutritionnels, d'identifier les groupes vulnérables et de développer des politiques éclairées pour améliorer la nutrition et la santé publique. Sur cette page, vous trouverez les rapports des enquêtes nutritionnelles réalisées par l'Institut National de la Statistique du Burundi, offrant des informations détaillées sur la situation nutritionnelle du pays.
</Typography>
<FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px',marginBottom:'20px' }}>
  <InputLabel id="year-select-label"> Sélectionnez une année de publication </InputLabel>
  <StyledSelect
    labelId="year-select-label"
    id="year-select"
    value={selectedYear}
    onChange={handleYearChange}
    label=" Sélectionnez une année de publication "
    variant="outlined"
  >
    <MenuItem value="Tous">Tous les rapports</MenuItem>
    {[...new Set(bulletinsData.map((bulletin) => new Date(bulletin.date).getFullYear()))]
      .sort((a, b) => b - a)
      .map((year) => (
        <MenuItem key={year} value={year.toString()}>
          {year}
        </MenuItem>
      ))}
  </StyledSelect>
</FormControl>
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <CardMedia
                      component="img"
                      sx={{ width: 91, height: 140, m: 2, cursor: 'pointer' }}
                      image={bulletin.image}
                      alt={bulletin.title}
                      
                      onClick={() => window.open(bulletin.link, '_blank')} 
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: '#388E3C' }}>
                        <a
                          href={bulletin.link}
                          style={{ textDecoration: 'none', color: 'inherit' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {<DownloadIcon />}{bulletin.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {bulletin.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié{moment(bulletin.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
          {visibleCount < filteredBulletins.length && (
            <Button
              onClick={handleShowMore}
              style={{ marginTop: '20px', backgroundColor: '#388E3C', color: 'white' }}
            >
              Plus de rapports
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default EnqueteNutrition;